import { useTranslation } from "react-i18next";

import { ClientStatus } from "types";

import classes from "./ClientStatusFilterBar.module.css";

interface FilterOption {
  id: ClientStatusFilter;
  labelKey: string;
}

export type ClientStatusFilter = ClientStatus | "ALL";

const MAIN_FILTERS: FilterOption[] = [
  { id: "ACTIVE", labelKey: "clientStatusFilters.active" },
  { id: "COMPLETED", labelKey: "clientStatusFilters.completed" },
  { id: "UNASSIGNED", labelKey: "clientStatusFilters.unassigned" },
  { id: "RESERVED", labelKey: "clientStatusFilters.reserved" },
  { id: "BLACKLISTED", labelKey: "clientStatusFilters.blacklisted" },
  { id: "ARCHIVED", labelKey: "clientStatusFilters.archived" },
];

interface ClientStatusFilterBarProps {
  value: ClientStatusFilter;
  onChange: (value: ClientStatusFilter) => void;
  allowAll?: boolean;
}

const ClientStatusFilterBar = ({ value, onChange, allowAll = false }: ClientStatusFilterBarProps) => {
  const { t } = useTranslation();
  const filters = allowAll
    ? [{ id: "ALL" as const, labelKey: "clientStatusFilters.all" }, ...MAIN_FILTERS]
    : MAIN_FILTERS;

  return (
    <div className={classes.wrapper}>
      <div className={classes.group}>
        {filters.map((filter) => (
          <button
            key={filter.id}
            type="button"
            className={`${classes.filterButton} ${value === filter.id ? classes.filterButtonActive : ""}`}
            onClick={() => onChange(filter.id)}
          >
            <span>{t(filter.labelKey)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ClientStatusFilterBar;
